import AuthBtnsComponents from './AuthBtnsComponent';

export default AuthBtnsComponents